import React from "react";

import { PanelWrapper } from "../../PanelWrapper";
import { IComparisonCardRaw, IComparisonItemRaw } from "../../../types/IComparisonCard";
import { IContentfulBackgroundColour } from "../../../types/IContentfulBackgroundColour";
import { IContentfulRichTextResponse } from "../../../types/IContentfulRichText";
import { ICTA } from "../../../types/ICTA";
import { transformRichText } from "../../../helpers/richText";
import { ProsAndConsV2Panel } from "./ProsAndConsV2Panel";
import { ComparisonPanelV1 } from "./ComparisonPanelV1";

const transformComparisonCards = (cards: IComparisonCardRaw[]) =>
  cards.map((card: IComparisonCardRaw) => ({
    ...card,
    items: card.items.map((item: IComparisonItemRaw) => ({
      ...item,
      content: item.content ? transformRichText(item.content.raw) : null,
    })),
  }));

export interface IComparisonPanelProps {
  backgroundColour: IContentfulBackgroundColour;
  content?: IContentfulRichTextResponse;
  callToAction?: ICTA;
  title?: string;
  variant?: "default" | "prosConsV2";
  headingType?: string;
  link?: { text: string; url: string };
  comparisonCards: IComparisonCardRaw[];
  isBetterV2?: boolean;
}

export const ComparisonPanel = (props: IComparisonPanelProps) => {
  const transformedProps = {
    ...props,
    comparisonCards: transformComparisonCards(props.comparisonCards),
    content: props.content ? transformRichText(props.content.raw) : null,
    variant: props.variant || "default",
  };
  const {
    backgroundColour,
    content,
    callToAction,
    comparisonCards,
    title,
    variant,
    headingType,
    link,
    isBetterV2,
  } = transformedProps;

  const getComparisonPanelVariant = () => {
    let panel;
    switch (variant) {
      case "prosConsV2": {
        panel = <ProsAndConsV2Panel comparisonCards={comparisonCards} />;
        break;
      }
      case "default":
      default: {
        panel = (
          <ComparisonPanelV1
            backgroundColour={backgroundColour}
            content={content}
            callToAction={callToAction}
            comparisonCards={comparisonCards}
            title={title}
            headingType={headingType}
            link={link}
          />
        );
        break;
      }
    }

    return panel;
  };

  return (
    <PanelWrapper backgroundColour={backgroundColour} isBetterV2={isBetterV2}>
      {getComparisonPanelVariant()}
    </PanelWrapper>
  );
};
